<template>
    <el-card>
        <div slot="header" class="move">
            <h3>Settlements</h3>
        </div>

        <el-table :data="paginatedSettlements" style="width: 100%" :loading="loading" class="fin-overflow-scroll">
            <el-table-column label="Customer" width="150">
                <template slot-scope="scope">
                    <div>
                        {{ getCustomerName(scope.row) }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="Broker" width="100">
                <template slot-scope="scope">
                    <el-avatar shape="circle" size="small" v-if="scope.row.broker_avatar"
                               :src="scope.row.broker_avatar"></el-avatar>
                    <el-avatar shape="circle" size="small" v-else>{{ getInitials(scope.row.broker) }}</el-avatar>
                </template>
            </el-table-column>
            <el-table-column label="Lender">
                <template slot-scope="scope">
                    <img class="fin-w-14" v-if="scope.row.lender_logo"
                         :src="scope.row.lender_logo"/>
                    <el-avatar shape="circle" size="small" v-else>{{ getInitials(scope.row.lender_name) }}</el-avatar>
                </template>
            </el-table-column>
            <el-table-column prop="referrer_name" label="Referrer"></el-table-column>
        </el-table>

        <el-pagination
            background layout="total, sizes, prev, pager, next, jumper"
            :page-size="maxPerPage"
            :current-page="currentPage"
            @current-change="loadMore"
            @size-change="loadMore"
            :total="settlements.length"
            class="fin-mt-3">
        </el-pagination>
    </el-card>
</template>

<script>
export default {
    name: 'Settlements',
    props: [
        'appearance',
        'tenantId',
        'dashboardId'
    ],
    data() {
        return {
            loading: false,
            settlements: [],
            currentPage: 1,
            maxPerPage: 10,
            showReadMore: true
        }
    },
    computed: {
        totalResults() {
            return Object.keys(this.settlements).length;
        },
        pageCount() {
            return Math.ceil(this.totalResults / this.maxPerPage);
        },
        pageOffest() {
            return this.maxPerPage * this.currentPage;
        },
        paginatedSettlements() {
            return this.settlements.slice(0, this.currentPage * this.maxPerPage);
        }
    },
    watch: {},
    mounted() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.settlements = _.get(event, 'settlements.settlements')
        })
    },
    created() {
        Echo.private(`dashboard.${this.tenantId}.${this.dashboardId}`).listen(".dashboard-live", (event) => {
            this.settlements = _.get(event, 'settlements.settlements')
        })
    },
    methods: {
        getInitials(string) {
            if (string) {
                let names = string.split(' '),
                    initials = names[0].substring(0, 1).toUpperCase();

                if (names.length > 1) {
                    initials += names[names.length - 1].substring(0, 1).toUpperCase();
                }

                return initials
            }

            return ''
        },
        getCustomerName(row) {
            return _.get(row, 'applicants.0.fullName', '');
        },
        loadMore(e) {
            this.currentPage = e;
        }
    }
}
</script>
